import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetPostCardNewsSucceed, EGetPostCardNewsActionType } from './types';
import { INewsList } from '../../../types/newsList';

export const getPostCardNewsSucceed: (data: INewsList) => TGetPostCardNewsSucceed = actionGenerator<
  EGetPostCardNewsActionType.Succeed,
  INewsList
>(EGetPostCardNewsActionType.Succeed);
